import { Outlet } from "react-router-dom";

function RequestMain(){
    return(
        <div className='h-full w-full'>
            <Outlet/>
        </div>
    )
}

export default RequestMain;